/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductCharacteristicsFacet from '../Product/ProductCharacteristicsFacet';
import BrandCityFacet from './BrandCityFacet';
import BrandCountryFacet from './BrandCountryFacet';
import BrandDistributionInCountriesFacet from './BrandDistributionInCountriesFacet';
import BrandDistributionInMarketFacet from './BrandDistributionInMarketFacet';
import BrandDistributionSoughtCountriesFacet from './BrandDistributionSoughtCountriesFacet';
import {
  characteristicsToggled,
  cityToggled,
  countryToggled,
  distributionInCountriesToggled,
  distributionInMarketToggled,
  distributionSoughtCountriesToggled,
  eventToggled,
  highlightToggled,
  hospitalityOfferingsToggled,
  lifestyleOfferingsToggled,
  // offeringToggled,
  openingHoursToggled,
  outdoorExperienceOfferingsToggled,
  regionToggled,
  wineExperienceOfferingsToggled,
} from './brandFilterReducer';
import BrandHighlightsFacet from './BrandHighlightsFacet';
import BrandHospitalityOfferingsFacet from './BrandHospitalityOfferingsFacet';
import BrandLifestyleOfferingsFacet from './BrandLifestyleOfferingsFacet';
// import BrandOfferingFacet from './BrandOfferingFacet';
import BrandOpeningHoursFacet from './BrandOpeningHoursFacet';
import BrandOutdoorExperienceOfferingsFacet from './BrandOutdoorExperienceOfferingsFacet';
import BrandRegionFacet from './BrandRegionFacet';
import BrandWineExperienceOfferingsFacet from './BrandWineExperienceOfferingsFacet';
import EventsFacet from './EventsFacet';

export default function BrandFilters({
  facets,
  dispatch,
  state,
  totalCount,
  count,
  children,
  ...rest
}) {
  // console.log(facets);  // Uncomment to debug the facets.
  return (
    <Box {...rest}>
      {children}
      <EventsFacet
        allValues={facets.event}
        selectedValues={state.events}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(eventToggled(value), isActive)}
        multiSelect
      />
      <BrandHighlightsFacet
        allValues={facets.highlights}
        selectedValues={state.highlights}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(highlightToggled(value), isActive)
        }
        multiSelect
      />
      {/* <BrandOfferingFacet
        allValues={facets.offerings}
        selectedValues={state.offerings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(offeringToggled(value), isActive)
        }
      /> */}

      <BrandWineExperienceOfferingsFacet
        allValues={facets.wineExperienceOfferings}
        selectedValues={state.wineExperienceOfferings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(wineExperienceOfferingsToggled(value), isActive)
        }
      />

      <BrandHospitalityOfferingsFacet
        allValues={facets.hospitalityOfferings}
        selectedValues={state.hospitalityOfferings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(hospitalityOfferingsToggled(value), isActive)
        }
      />
      <BrandLifestyleOfferingsFacet
        allValues={facets.lifestyleOfferings}
        selectedValues={state.lifestyleOfferings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(lifestyleOfferingsToggled(value), isActive)
        }
      />
      <BrandOutdoorExperienceOfferingsFacet
        allValues={facets.outdoorExperienceOfferings}
        selectedValues={state.outdoorExperienceOfferings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(outdoorExperienceOfferingsToggled(value), isActive)
        }
      />

      <BrandCountryFacet
        allValues={facets.country}
        selectedValues={state.countries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(countryToggled(value), isActive)
        }
      />
      <BrandRegionFacet
        multiSelect
        allValues={facets.region}
        selectedValues={state.regions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(regionToggled(value), isActive)}
      />
      <ProductCharacteristicsFacet
        allValues={facets.characteristics}
        selectedValues={state.characteristics}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(characteristicsToggled(value), isActive)
        }
      />
      <BrandCityFacet
        allValues={facets.city}
        selectedValues={state.cities}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(cityToggled(value), isActive)}
      />
      <BrandOpeningHoursFacet
        allValues={facets.openingHours}
        selectedValues={state.openingHours}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(openingHoursToggled(value), isActive)
        }
      />

      <BrandDistributionInMarketFacet
        allValues={facets.distributionInMarket}
        selectedValues={state.distributionInMarket}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(distributionInMarketToggled(value), isActive)
        }
      />

      <BrandDistributionInCountriesFacet
        allValues={facets.distributionInCountries}
        selectedValues={state.distributionInCountries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(distributionInCountriesToggled(value), isActive)
        }
      />

      <BrandDistributionSoughtCountriesFacet
        allValues={facets.distributionSoughtCountries}
        selectedValues={state.distributionSoughtCountries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(distributionSoughtCountriesToggled(value), isActive)
        }
      />
    </Box>
  );
}

export const fragment = graphql`
  fragment bb_BrandFilters on Bottlebooks_AbstractBrand {
    openingHours {
      dayOfWeek
    }
    wineExperienceOfferings
    hospitalityOfferings
    lifestyleOfferings
    outdoorExperienceOfferings
    offeringTypes
  }
  fragment bb_BrandFilters_RegisteredBrand on Bottlebooks_RegisteredBrand {
    partnerId
    isSeekingDistribution
    highlights: customFieldValue(key: "highlights") {
      ...FieldValue
    }
  }
  fragment BrandFilters on AbstractBrand {
    event {
      name
    }
    country(full: true)
    regions
    city
    distributionInCountries
    distributionSoughtCountries
  }

  # This is for characteristics
  fragment bb_BrandProductFilters_RegisteredProductConnection on Bottlebooks_RegisteredProductConnection {
    byIsCertifiedOrganic: group(field: isCertifiedOrganic) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
    # The directory shouldn't care if it is certified or just made with organic grapes
    byIsOrganic: group(field: isOrganic) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
    byIsBiodynamic: group(field: isBiodynamic) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
    byIsVegan: group(field: isVegan) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
    byIsVegetarian: group(field: isVegetarian) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
    byIsSustainable: group(field: isSustainable) {
      fieldValue
      byPartner: group(field: partnerName, first: 1) {
        nodes {
          partnerId
          producerId
        }
      }
    }
  }
`;
